export class IReleaseNotes {
  id: number;
  version: string;
  releaseDate: Date;
  contentDE: string;
  contentEN: string;
}
